import { createPricingVehicleRequest } from "../../data/pricingVehicleApi";
import { validatePricingVehiclePayload } from "../validator/validatePricingVehiclePayload";

export async function createPricingVehicleUseCase(payload) {
  const error = validatePricingVehiclePayload(payload);

  if (error) {
    throw new Error(error);
  }

  return await createPricingVehicleRequest(payload);
}
